/** This is a sample environment config file.
 * Save a copy of this as 'environent.config' and place it in src
 * directory.  Adjust any parameters you might need.  DO NOT commit the
 * environment file to source control.
 */

export default {
  baseUrl: 'https://api.tanninalert.com/api',
};




//////////////////
// WEBPACK FOOTER
// ./src/environment.config
// module id = null
// module chunks = 